import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import ServiceLogSettings from './ServiceLogSettings';

const ServiceLogs = React.lazy(() => import('./ServiceLogs'));

export default function ServiceLogsCard() {
  return (
    <Card raised>
      <CardHeader
        title="Service Errors"
        titleTypographyProps={{ color: 'error', fontSize: 20 }}
        action={<ServiceLogSettings />}
      />
      <CardContent
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          pt: 0,
          '&:last-child': { pb: 1.5 },
        }}
      >
        <React.Suspense fallback={<CircularProgress />}>
          <ServiceLogs />
        </React.Suspense>
      </CardContent>
    </Card>
  );
}
